import { BrowserModule } from "@angular/platform-browser";
import { LOCALE_ID, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { AuthInterceptorInterceptor } from "./core/interceptors/auth-interceptor.interceptor";

import localEs from "@angular/common/locales/es-CL";
import { registerLocaleData } from "@angular/common";
import { AgmCoreModule } from '@agm/core';
import { NgxGoogleAnalyticsRouterModule } from "ngx-google-analytics";
import { SharedModule } from "./shared/shared.module";


export var google: any;

registerLocaleData(localEs, "es");

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AccordionModule.forRoot(),
    SharedModule,
    NgxGoogleAnalyticsRouterModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBoWVPyBLBNJVeEWAobDB1ngjL8WuLEIIY',
      libraries: ['places', 'drawing', 'geometry'],
      language: 'es',
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: "es",
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
